"use client"

import { useEffect, useState } from "react"
import { Button } from "../ui/button";
import { cn } from "@/lib/utils";
import { ChevronRight } from "lucide-react";
import { getDocumentationStructuresPreBuild } from "@/services/documentation.service";

export default function DocumentationSidebar() {
    const [hideSidebar, setHideSidebar] = useState(false);
    let sidebarFetched = false;
    

    const prebuildDocumentationSidebar = async () => {
        sidebarFetched = true;
        const result = await getDocumentationStructuresPreBuild();
        document.getElementById("documentationTree")!.innerHTML = result;
    }


    useEffect(() => {
        if(!sidebarFetched){
            prebuildDocumentationSidebar();
        }
    }, []);

    return (
        <div>
            <Button
                data-sidebar="trigger"
                data-slot="sidebar-trigger"
                variant="ghost"
                size="icon"
                className={cn("size-7", "dark:text-white dark:hover:text-black")}
                onClick={() => {
                    setHideSidebar(!hideSidebar)
                }}
                >
                
                <ChevronRight className={cn("transition-transform duration-200 ease-linear", hideSidebar ? "" : "rotate-90")}/>
            </Button>
            <div
                className={cn(hideSidebar ? "h-[0px] p-0" : "p-1 ps-2 h-full", "overflow-hidden transition-[left,right,width,height] duration-200 ease-linear rounded-lg border-2 border-white")}
                id="documentationTree"
            >
            </div>
        </div>
    )
}